import React from 'react';
import { FormattedMessage } from 'react-intl';
import StatsWidgetNumber from '@rio-cloud/rio-uikit/StatsWidgetNumber';
import StatsWidgetSpacer from '@rio-cloud/rio-uikit/StatsWidgetSpacer';
import { InstallationStatusCounter } from '~/api/models/installationStatusCounter';
import { STATISTICS_CONFIG } from '~/features/campaigns/constants/statisticsConfig';
import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';

interface StatisticsBodyProps {
  statistics?: InstallationStatusCounter;
  isLoading: boolean;
  openTab?: (installationStatus?: string, stageId?: string) => void;
}

const CampaignStatisticsBody: React.FC<StatisticsBodyProps> = ({ statistics, isLoading, openTab }) => {
  return (
      <>
      {STATISTICS_CONFIG.filter(config => config.key !== 'targetNumber').map((config, index) => (
        <React.Fragment key={config.key}>
          <div onClick={() => openTab?.(config.installationStatus)}
               style={{ cursor: config.installationStatus ? 'pointer' : 'default' }}>
            <StatsWidgetNumber
                className={config.colorClass}
                value={!isLoading ? statistics?.[config.key] : <ContentLoader width={50}/>}
                label={<FormattedMessage id={config.labelId}/>}
            />
          </div>
          {index !== STATISTICS_CONFIG.filter(config => config.key !== 'targetNumber').length - 1 &&
              <StatsWidgetSpacer/>}
        </React.Fragment>
      ))
      }</>
  );
};

export default CampaignStatisticsBody;
